export default __webpack_public_path__ + "static/media/more-info-2-3.8568930b.png";